import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function ContactFill(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    d: "M15.902 14.954l-.696.607c-.34.297-.812.409-1.231.242-3.015-1.2-4.467-4.117-5.028-5.592-.199-.523.019-1.092.482-1.403a1.33 1.33 0 00.274-1.958L8.656 5.605 7.67 4.462a1.329 1.329 0 00-2.021.007L4.603 5.7c-.51.598-.733 1.39-.527 2.15.492 1.815 1.747 5.338 4.58 8.188 2.913 2.93 6.18 3.728 7.742 3.945.6.083 1.188-.126 1.66-.507l1.441-1.16c.621-.5.673-1.43.11-1.997l-.18-.182a1.34 1.34 0 00-.217-.176l-1.71-1.118a1.328 1.328 0 00-1.6.112z"
  }));
}

export default ContactFill;